import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UBCVancouver = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of British Columbia (UBC)"
      universityShortName="UBC"
      slug="ubc-vancouver"
      seoTitle="UBC Study Rooms | Vancouver Campus Library Study Guide"
      seoDescription="Complete guide to study rooms at UBC Vancouver. Find Irving K. Barber Learning Centre, Ridington Room, and group study spaces. Plus free 24/7 online alternative."
      seoKeywords="ubc study rooms, ubc library, irving k barber learning centre, ridington room, ubc vancouver study spaces, ikb library"
      canonicalUrl="/study-room/ubc-vancouver/"
      heroDescription="A comprehensive guide to study rooms and spaces at UBC Vancouver, including the Irving K. Barber Learning Centre and the iconic Ridington Room."
      libraryWebsiteUrl="https://services.library.ubc.ca/"
      libraryWebsiteName="UBC Library"
      studySpaces={[
        {
          name: "Irving K. Barber Learning Centre (IKB)",
          features: "Seven group study rooms plus dedicated reading rooms—the Musqueam Reading Room and Nass Reading Room—designated as silent spaces.",
          feedback: "Students flock to IKB; seating becomes scarce during mid-terms. Silence is strictly enforced in reading rooms."
        },
        {
          name: "Ridington Room",
          features: "Ornate, Harry Potter-esque space with painfully quiet atmosphere and beautiful architecture.",
          feedback: "Fills fast; arrive early if you want a spot. Beloved for its aesthetic but can feel intimidating."
        },
        {
          name: "Music, Art & Architecture Library",
          features: "Five group rooms and two digital-media rooms with screens and technology.",
          feedback: "More relaxed atmosphere than IKB; rooms have screens for presentations."
        },
        {
          name: "AMS Student Nest (EGG Lounge)",
          features: "More social study environment in the student union building.",
          feedback: "Preferred by students who like ambient noise; not ideal for silent study."
        },
        {
          name: "Nest Rooftop Garden & MacMillan Bloedel Atrium",
          features: "Outdoor and atrium spaces with outlets and natural light.",
          feedback: "Great on sunny days; can be noisy during peak hours."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            Start early in the day if you want a spot in the <strong>Ridington Room</strong>; it fills fast. For group work, the <strong>Music, Art & Architecture Library's rooms</strong> feel more relaxed and have screens.
          </p>
          <p className="mb-4">
            On sunny days, take your books to the <strong>rooftop garden of the Nest</strong> or the <strong>MacMillan Bloedel Atrium</strong>; both provide outlets and natural light.
          </p>
          <p>
            The <strong>IKB's reading rooms</strong> (Musqueam and Nass) are designated silent spaces—perfect for focused exam preparation.
          </p>
        </>
      }
      summaryTips={[
        "Arrive early for Ridington Room: This iconic Harry Potter-esque space fills quickly.",
        "Book IKB group rooms in advance: Seven rooms available but high demand during exams.",
        "Try Music, Art & Architecture Library: More relaxed atmosphere with screens in group rooms.",
        "Use the Nest for social studying: EGG lounge suits those who prefer ambient noise.",
        "Use CSW for guaranteed quiet: Virtual study rooms offer 24/7 access when campus is crowded."
      ]}
    />
  );
};

export default UBCVancouver;
